import { matchPath } from "react-router-dom";

// ──────────────────────────────────────────────
// Lista blanca de rutas aptas para mobile (SoloEscritorio, F1 de la auditoría de anchos/mobile).
// Agregar una ruta ACÁ es la ÚNICA forma de habilitarla en mobile — no se decide por componente.
// Decisión de Ignacio (docs/decisiones/2026-09-23-auditoria-anchos-escalado-mobile.md §9):
// lo comercial (landing, inventario, portafolio, mediakit) + lo técnico imprescindible (login,
// confirmación de acceso por mail, redirect) + la Ronda (única pantalla interna mobile-first).
// `/ficha-edificio/:id` NO entra por ahora (no nombrada por Ignacio; se suma si se confirma que
// se abre por QR desde el teléfono).
// Prioridad 2 (docs/decisiones/2026-09-27-mobile-prioridad-vistas-publicas.md): Canva o PDF
// embebido, se adaptan solos — `/edificios`, mediakit full y cbre, `/investigacion-ipsos`.
// ──────────────────────────────────────────────
export const RUTAS_MOBILE = [
  "/",
  "/landing",
  "/td",
  "/inventario",
  "/portafolio",
  "/mediakit",
  "/mediakit2",
  "/edificios",
  "/mediakit-edificios-full",
  "/mediakit-edificios-full-cbre",
  "/investigacion-ipsos",
  "/login",
  "/auth/confirm",
  "/redirect",
  "/admin/infraestructura/ronda",
];

// Soporta patrones con parámetros (ej. "/ficha-edificio/:id") con la misma semántica que las
// <Route> de react-router — no una comparación de string ingenua.
export const esRutaMobile = (pathname) =>
  RUTAS_MOBILE.some((patron) => matchPath({ path: patron, end: true }, pathname) !== null);
